import { render, staticRenderFns } from "./study-navigation.vue?vue&type=template&id=2295b045&scoped=true&"
import script from "./study-navigation.vue?vue&type=script&lang=ts&"
export * from "./study-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./study-navigation.vue?vue&type=style&index=0&id=2295b045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295b045",
  null
  
)

export default component.exports